import React from 'react';
import { classNameTriskeleParser } from '../utilities/customStyles';

const defaults = {
  kind: 'maintenance',
  line1: 'Maintenance Mode',
  line2: 'Prism is currently undergoing maintenance.',
  line3: 'Please check again shortly!',
};

const Error = (props) => {
 const finalProps =
    Object.keys(props).length === 0 ? defaults : props;

  const { kind, line1, line2, line3 } = finalProps;
  const emptyState = classNameTriskeleParser('Empty State', 'Astronaut', 'Image');
  const maintenanceState = classNameTriskeleParser('Maintenance State', 'Astronaut', 'Image');

  const headingText = classNameTriskeleParser('Heading 2', 'Black', 'Text');
  const bodyText = classNameTriskeleParser('Body 1', 'Black', 'Text');
  return (
    <div style={{ margin: 'auto', textAlign: 'center', height: '100vh' }}>
      <div className={`${kind === 'empty' ? emptyState : maintenanceState}`} style={{ margin: 'auto', width: '300px', height: '300px' }} />
      {line1 && <p className={headingText}>{line1}</p>}
      {line2 && <p className={bodyText}>{line2}</p>}
      {line3 && <p className={bodyText}>{line3}</p>}
    </div>
  );
};


export default Error;
